import { render, staticRenderFns } from "./AirTicketHelp.vue?vue&type=template&id=681c64a4&scoped=true"
import script from "../../assets/ts/tripinfo/AirTicketHelp.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/tripinfo/AirTicketHelp.ts?vue&type=script&lang=ts&external"
import style0 from "./AirTicketHelp.vue?vue&type=style&index=0&id=681c64a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c64a4",
  null
  
)

export default component.exports